import { APP_EVENT_BUS } from '@/core/enums/app.enum';
import Quill from 'quill';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-collaborative-text-toolbar',
  components: {
    EdTableModal: () => import('@/components/common/ed-collaborative-text-editor/ed-table-modal.vue'),
  }
})
export default class EdCollaborativeTextToolbar extends Vue {

  @Prop({default:'toolbar'}) readonly toolbarId: string;
  @Prop({default:true}) readonly mediaOptions: boolean;
  @Prop({default:false}) readonly enableFormulas: boolean;
  @Prop({default:false}) readonly undoRedoOptions: boolean;
  @Prop({}) readonly quillEditor: any;
  @Prop({default:false}) readonly isOnline: boolean;
  @Prop({default:false}) readonly showHistory: boolean;
  @Prop({default:false}) readonly showNetwork: boolean;
  @Prop({default:false}) readonly showUserStatus: boolean;
  @Prop({default:false}) readonly readOnly: boolean;
  
   
  private dialog: any = false;

  private headerSizes = {
    1 : '32px',
    2 : '26px',
    3 : '24px',
    4 : '20px',
    5 : '16px',
    6 : '12px'
  }

  private addFonts() {
    let fonts = ['Sans Serif', 'Serif', 'Arial', 'Courier', 'Garamond', 'Tahoma', 'Times New Roman', 'Verdana'];

    function getFontName(font) {
      return font.toLowerCase().replace(/\s/g, '-');
    }
    let fontNames = fonts.map(font => getFontName(font));
    // add fonts to style
    let fontStyles = '';
    fonts.forEach(function(font) {
      let fontName = getFontName(font);
      fontStyles += '.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=' + fontName + ']::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=' + fontName + ']::before {' +
          'content: "' + font + '";' +
          'font-family: "' + font + '", sans-serif;' + '}' +
          '.ql-font-' + fontName + '{' + ' font-family: "' + font + '", sans-serif;' + '}';
    });
    let node = document.createElement('style');
    node.innerHTML = fontStyles;
    document.body.appendChild(node);

    let font : any = Quill.import('formats/font');
    font.whitelist = fontNames;
    Quill.register(font, true);
  }

  private addSizes() {
    let size : any = Quill.import('attributors/style/size');
    const fontSizeArr = ['8px','9px','10px','12px','14px','16px','20px','24px','26px', '32px','42px','54px','68px','84px','98px'];
    size.whitelist = fontSizeArr;
    Quill.register(size, true);
  }

  undo(): void {
    this.quillEditor.history.undo();
  }

  redo(): void {
    this.quillEditor.history.redo();
  }

  mounted() {
    this.loadToolbarFinished();
    this.registerToolbarModules();
    this.$edEventBus.$on(APP_EVENT_BUS.LANGUAGE_CHANGED, this.updateTitles);
  }

  @Emit('loadToolbarFinished')
  private loadToolbarFinished() {
    return true;
  }

  @Emit('openVersionHistory')
  public openVersionHistory(){
    return true;
  }

  private registerToolbarModules() {
    this.addFonts();
    this.addSizes();
  }

  private showTableModal() {
    this.dialog = true;
  }


  private insertTable(tableData) {
    this.dialog = false;
    setTimeout(() => {
      this.quillEditor.focus();
      let tableModule = this.quillEditor.getModule('table')
      tableModule.insertTable(parseInt(tableData.rows), parseInt(tableData.columns));
    }, 250);
  }

  private cancelTable() {
    this.dialog = false;
  }

  public selectHeader(event) {
    let fontSizeElement:any = document.querySelector('select[id="slFontSize"]');
    setTimeout(() => {
      fontSizeElement.value = event.target.value == 'false' ? '14px' : this.headerSizes[event?.target?.value];
      fontSizeElement.dispatchEvent(new Event('change'))
    }, 0);
  }


  private updateTitles() {
    document.getElementById('slHeader').title = this.$t('courses.textEditor.menu.hading').toString()
    document.getElementById('slFontSize').title = this.$t('courses.textEditor.menu.fontSize').toString()
    document.getElementById('slFont').title = this.$t('courses.textEditor.menu.fontFamily').toString()
    document.getElementById('slColor').title = this.$t('courses.textEditor.menu.fontColor').toString()
    document.getElementById('slBgColor').title = this.$t('courses.textEditor.menu.backgroundColor').toString()
  }

}
